import json2csv from 'json2csv'
import i18n from '../i18n/i18n.js'
import newOrdersApi from '../api/moudles/newOrders'

import { markScrollLocation } from '../store/modules/common'
import http from '../api/http'
import config from '../api/config'
import { json } from 'd3'
import { resolve } from 'any-promise'


export default {

	/**模糊查找,
	 * target:用户传入的字符,
	 * text：
	 */

	matchStoreDesc(target,text){
		let a = target; //用户输入的字符串
		let str = ['',...a,''].join('.*'); //转化成正则格式的字符串
		let reg = new RegExp(str) //正则
		return reg.test(text) //去匹配待查询的字符串
		console.log('injgn',reg.test(text))
		
	 },

	JudegeBindStore (list) {
		let type=0
		let storeIds=[]
		for(let i=0;i<list.length;i++){
		  let storeItem=list[i].storeItem
		  if(storeItem == null || storeItem == []){
			type=1
		  }else{
			if(storeIds.includes(storeItem.storeId)){
			  storeIds.push(storeItem.storeId)
			}
		  }
		}
		type=storeIds.length > 1 ? 1 :type
		return type
	  
	  },

	/**获取滚动条位置,
	 * userId:this.userId,
	 */

	 getMarkLocation: function() {
		let location=JSON.parse(localStorage.getItem('scroll'))
		console.log('location',location)
		return Number(location) 
	},



	/**标记滚动条位置,
	 * userId:this.userId,
	 */

	 markLocationScroll: function(userId) {
		setTimeout(() => {
			window.addEventListener('scroll', function(){
				var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				//变量windowHeight是可视区的高度
				var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
				//变量scrollHeight是滚动条的总高度
				var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
				//写后台加载数据的函数
				// console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
				localStorage.setItem('scroll',scrollTop)
				markScrollLocation(scrollTop)
			})
		},1000)
	},




	 sengMsgBySystem:async function(payload) {
		const res = await http({
			url: config.SENT_MESSAGE,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res
	},


	/**cacheKey:'C_rate',
	 * userId:this.userId,
	 */

	getInfoByCache:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_GET_USERCACHE,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data.data ? JSON.parse(res.data.data.cacheData) : null
	},

	/**cacheKey:'C_rate',
	 * userId:this.userId,
	 * cacheData:JSON.stringify(this.rate)
	 * 
	 */

	
	updateInfoByCache:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_SET_USERCACHE,
			method: 'post',
			data:{
				...payload
			}
	
		})
		return res.data
	},
	/**
	 * 根据shopee商品详情的url,获取itemId,shopid

	 * @returns {arr}  
	 */

	getParamsInProductUrl: function(url) {
		let ids = null
		if (url.search('-i\\.') != -1) {
		ids = url.substring(url.search('-i\\.') + 3).split('.')
		} else if (url.search('product') != -1) {
		ids = url.substring(url.search('product') + 8).split('/')
		}
		console.log(ids)
		if(ids.length && ids[1].indexOf('?') > -1) {
			ids[1]=ids[1].split('?')[0]
		}
		return ids
	},
	/**
	 * 获取国家的货币
	 * params th/TH
	 * @returns {string}  
	 */
	getCurrency: function(country) {
		let temp = 0
		switch (country) {
		  case 'ID':
		  case 'id':
			// 印尼
			temp = 'IDR'
			break
		  case 'MY':
		  case 'my':  
			// 马来
			temp = 'MYR'
			break
		  case 'TH':
		  case 'th':	  
			// i18n.t("h5.DSX_index_th")
			temp = 'THB'
			break
		  case 'VN':
		  case 'vn':
			// 越南
			temp = 'VND'
			break
		  case 'TW':
		  case 'tw':
			// 台湾
			temp = 'TWD'
			break
		  case 'PH':
			// 菲律宾
			temp = 'PHP'
			break
		  case 'SG':
		  case 'sg':
			// 新加坡
			temp = 'SGD'
			break
		  case 'BZ':
		  case 'bz':
			// 巴西
			temp = 'BRL'
			break
		}
		return temp
	  },
	/**
	 * 对字符串集合随机排列，随机输出指定的长度
	 * @returns {string}  
	 */
	randomString(length) {
	var str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	var result = '';
	for (var i = length; i > 0; --i) 
		result += str[Math.floor(Math.random() * str.length)];
	return result;
	},
	/**
	 * 获取当天的日期
	 * @returns {s2}  结束日期 yyyy-MM-dd
	 */
	getTodayDate(){
		var day2 = new Date();
		day2.setTime(day2.getTime());
		var s2 = day2.getFullYear()+"-" + (day2.getMonth()+1) + "-" + day2.getDate();
		return s2
	},
	/**
	 * 计算两个日期之间的天数
	 * @param dateString1  开始日期 yyyy-MM-dd
	 * @param dateString2  结束日期 yyyy-MM-dd
	 * @returns {number} 如果日期相同 返回一天 开始日期大于结束日期，返回0
	 */
	getDaysBetween(dateString1,dateString2){
		var  startDate = Date.parse(dateString1);
		var  endDate = Date.parse(dateString2);
		if (startDate>endDate){
			return 0;
		}
		if (startDate==endDate){
			return 1;
		}
		var days=(endDate - startDate)/(1*24*60*60*1000);
		return  days;
	},
	//计算用户上传分销产品的毛利 --利率转换
	interestRateConversion:function(country,price){
		let rate={
			'TH':0.1942,
			'MY':1.5473,
			'PH':0.1292,
			'VN':0.0003,
			'TW':0.2329,
			'ID':0.0005,
		}
		
		let ttp=price*rate[country]
		return ttp.toFixed(2)
	},
	getStore(){
        let arr1 = [];
        let arr2 = [];
        let list = [];
        JSON.parse(localStorage.getItem("userInfo")).stores.forEach((p) => {
            if (p.isUsed) {
              if (p.storeType == 1) {
                arr1.push({
                  label: p.storeName,
                  value: p.storeId,
                });
              } else {
                arr2.push({
                  label: p.storeName,
                  value: p.storeId,
                });
              }
            }
          });
           list = [...arr1, ...arr2];
          return list
    },
	getCountryName: function(id) {
		let platform=''
		switch (id) {
		case 'TH':
		case 'th':
		platform = i18n.t("h5.DSX_index_th")
		break

		case 'MY':
		case 'my':
		platform = i18n.t("h5.DSX_index_my")
		break

		case 'ID':
		case 'id':
		platform = i18n.t("h5.DSX_index_id")
		break

		case 'PH':
		case 'ph':
		platform = i18n.t("h5.DSX_index_ph")
		break
		// 越南
		case 'VN':
		case 'vn':
		platform = i18n.t("h5.DSX_index_vn")
		break
		// 台湾
		case 'TW':
		case 'tw':
		platform = i18n.t("h5.DSX_index_tw")
		break
		// 新加坡
		case 'SG':
		case 'sg':
		platform = i18n.t("other.a2232")
		break
		// 中国
		case 'CN':
		case 'cn':
		platform = i18n.t("other.a2335")
		break

		// 巴西
		case 'BZ':
		case 'bz':
		platform = i18n.t("h5.DSX_index_bz")
		break
				  
		  	
			
		  default:
			platform = i18n.t("other.a354")
		}
		return platform
	  },

	getUrlByItemIDandCountry(country,itemId,shopId){
		const param={
			'ID':'https://shopee.co.id/api/v4/item/get?itemid=' + itemId + '&shopid=' + shopId ,
			'TH':'https://shopee.co.th/api/v4/item/get?itemid=' + itemId + '&shopid=' + shopId ,
			'PH':'https://shopee.ph/api/v4/item/get?itemid=' + itemId + '&shopid=' + shopId ,
			'MY':'https://shopee.com.my/api/v4/item/get?itemid='+ itemId + '&shopid=' + shopId ,
			'VN':'https://shopee.vn/api/v4/item/get?itemid='+ itemId + '&shopid=' + shopId,
			'TW':'https://xiapi.xiapibuy.com/api/v4/item/get?itemid='+ itemId + '&shopid=' + shopId,
			'SG':'https://shopee.sg/api/v4/item/get?itemid='+ itemId + '&shopid=' + shopId,
			'BR':'https://br.xiapibuy.com/api/v2/item/get?itemid='+ itemId + '&shopid=' + shopId,
			
		}
		
		return param[country]
	},
	showShopNameByshopId(id){
		let shopee=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
		let lazada=JSON.parse(localStorage.getItem('userInfo')).lazadaShops
		let tiktokShops=JSON.parse(localStorage.getItem('userInfo')).tiktokShops
		let temuAuth=JSON.parse(localStorage.getItem('userInfo')).temuAuth
		let shopList=[]
		if(shopee){
			shopee.forEach(p => {
				shopList.push({
					shopId:p.shopId,
					shopName:p.shopName,
					country:p.country
				})
			})
		}
		
		if(lazada){
			lazada.forEach(p => {
				shopList.push({
					shopId:p.sellerId,
					shopName:p.name,
					country:p.country
				})
			})
		}

		if(tiktokShops){
			tiktokShops.forEach(p => {
				shopList.push({
					shopId:p.shopId,
					shopName:p.shopName,
					country:p.region
				})
			})
		}

		if(temuAuth){
			temuAuth.forEach(p => {
				shopList.push({
					shopId:p.shopId,
					shopName:p.shopName,
					country:p.shopSite
				})
			})
		}
		
		let ttp=shopList.find(item => item.shopId == id)
		return ttp ? ttp.shopName : i18n.t("other.a354")


	},
	//获取用户的默认分销仓ID，判断是否是当前帐号所有分销仓的ID其中之1，是就直接返回，否则返回数组里的第1个
	getDefaultDistributestoreID(){
		let distributStore=JSON.parse(localStorage.getItem('userInfo')).stores
		let DefaultDistributestoreID=JSON.parse(localStorage.getItem('DefaultDistributestoreID'))
		let storeList=[]
		let storeId=null
		if(distributStore){
			distributStore.forEach(p => {
				if(p.storeType == 4 && p.isUsed){
					storeList.push(p)
				}
			})
		}
		if(storeList){
			storeId=storeList.find(item => item.storeId == DefaultDistributestoreID).storeId
		}

		return storeId ? storeId : storeList[0].storeId
	},

	//用户每次选择分销仓时，暂存为默认的分销仓ID
	setDefaultDistributestoreID:function(id){
		localStorage.setItem('DefaultDistributestoreID',id)
	},
	getHost: function(url) {
		return url.substring(0, url.indexOf('/', 8) + 1)
	},
	calculateAveragePrice(models, currency, price_max, price_min) {
		if (models && models.length) {
		  // 计算平均值
		  let result = utils.calculateAverage(models, 'price')
		  return this.parseRate(result, currency)
		}
		return this.parseRate((price_max + price_min) / 2, currency)
	  },
 /**
   * 获取日期间隔
   */
  getDayInterval: function(time) {
    let added = new Date(time * 1000)
    let today = new Date()
    let dayNum = parseInt(Math.abs(today - added) / 1000 / 60 / 60 / 24)
    return dayNum
  },

	/**
   * 计算销售额  平均值 * 销量
   */

	calculateTotalSales(averagePrice, sold) {
		return averagePrice * sold
	  },
	/**
   * 获取两值中的最小值
   */
	getMin: function(val1, val2) {
		return val1 < val2 ? val1 : val2
	},

	/**
   * 转换汇率
   */
	 parseRate: function(price, currency) {
		let temp = 0
		switch (currency) {
		  case 'IDR':
			case 'ID':
			// 印尼
			temp = (price / 100000) * 0.0004838
			break
		  case 'MYR':
			case 'MY':
			// 马来
			temp = (price / 100000) * 1.6353
			break
		  case 'THB':
			case 'TH':
			// i18n.t("h5.DSX_index_th")
			temp = (price / 100000) * 0.2233
			break
		  case 'VND':
			case 'VN':
			// 越南
			temp = (price / 100000) * 0.0003051
			break
		  case 'TWD':
			case 'TW':
			// 台湾
			temp = (price / 100000) * 0.2375
			break
		  case 'PHP':
			case 'PH':
			// 菲律宾
			temp = (price / 100000) * 0.1405
			break
		  case 'SGD':
			case 'SG':
			// 新加坡
			temp = (price / 100000) * 5.0209
			break
		  case 'BRL':
			case 'BR':
			// 巴西
			temp = (price / 100000) * 1.2879
			break
		}
		return temp
	  },

	 /**
   * 计算数组对象里指定 Object.key 的平均值
   */
	  calculateAverage: function(arr, key) {
		if (arr && arr.length) {
		  let average = 0
		  for (let i = 0; i < arr.length; i++) {
			average += arr[i][key]
		  }
		  return average / arr.length
		}
	  },


	getImageUrl: function(url, image) {
		let host = url
		let platform = ''
		switch (host) {
		  // 印尼
		  case 'shopee.co.id':
		  case 'id.xiapibuy.com':
		  case 'ID':
			case 'https://shopee.co.id/api/v4/item/get?':
			platform = 'https://s-cf-id.shopeesz.com/file/'
			
			break
		  // 马来
		  case 'shopee.com.my':
		  case 'my.xiapibuy.com':
		  case 'MY':
		  case 'https://shopee.com.my/api/v4/item/get?':
			platform = 'https://s-cf-my.shopeesz.com/file/'
			break
		  // i18n.t("h5.DSX_index_th")
		  case 'shopee.co.th':
		  case 'th.xiapibuy.com':
		  case 'TH':
		  case 'https://shopee.co.th/api/v4/item/get?':
			case 'https://shopee.ph/api/v4/item/get?':	  
			platform = 'https://s-cf-th.shopeesz.com/file/'
			break
		  // 菲律宾
		  case 'ph.xiapibuy.com':
		  case 'shopee.ph':
		  case 'PH':
		  case 'https://ph.xiapibuy.com/api/v4/item/get?':
			platform = 'https://s-cf-ph.shopeesz.com/file/'
			break
		  // 新加坡
		  case 'sg.xiapibuy.com':
		  case 'shopee.sg':
			case 'https://sg.xiapibuy.com/api/v4/item/get?':
			case 'SG':
			platform = 'https://s-cf-sg.shopeesz.com/file/'
			break
		  // 越南
		  case 'vn.xiapibuy.com':
		  case 'shopee.vn':
			case 'https://vn.xiapibuy.com/api/v4/item/get?':
			case 'https://shopee.vn/api/v4/item/get?':
			case 'VN':
			platform = 'https://s-cf-vn.shopeesz.com/file/'
			break
		  // 台湾
		  case 'xiapi.xiapibuy.com':
		  case 'shopee.tw':
		  case 'www.shopee.tw':
			case 'TW':
			case 'https://xiapi.xiapibuy.com/api/v4/item/get?':
			platform = 'https://s-cf-tw.shopeesz.com/file/'
			break
		  // 巴西
		  case 'shopee.com.br':
		  case 'br.xiapibuy.com':
		  case 'BR':
			platform = 'https://s-cf-br.shopeesz.com/file/'
			break
		  default:
			platform = ''
		}
		return platform + image
	  },


	getSimilaryData(country,str){
		const baseUrl='&similar_product_limit=24&similar_product_offset=0'
		const url={
			ph:"https://shopee.ph/api/v2/recommendation/bundle/product_detail_page?",
			my:"https://shopee.com.my/api/v2/recommendation/bundle/product_detail_page?",
			th:"https://shopee.co.th/api/v2/recommendation/bundle/product_detail_page?",
			vn:"https://shopee.vn/api/v2/recommendation/bundle/product_detail_page?",
			tw:"https://xiapi.xiapibuy.com/api/v2/recommendation/bundle/product_detail_page?",

		}

		return url[country] + str + baseUrl
		// 'https://shopee.ph/api/v2/recommendation/bundle/product_detail_page?catid=131761&itemid=5064185012&shopid=33543194&you_may_also_like_limit=24&you_may_also_like_offset=0'
		// 'https://shopee.com.my/api/v2/recommendation/bundle/product_detail_page?catid=199414&itemid=191451719&shopid=8185809&you_may_also_like_limit=24&you_may_also_like_offset=0'
		// 'https://shopee.co.th/api/v2/recommendation/bundle/product_detail_page?catid=131853&itemid=2050735960&shopid=31686082&you_may_also_like_limit=24&you_may_also_like_offset=0'
		// 'https://shopee.vn/api/v2/recommendation/bundle/product_detail_page?catid=178514&itemid=591989399&shopid=37251933&similar_product_limit=24&similar_product_offset=0'
		// 'https://xiapi.xiapibuy.com/api/v2/recommendation/bundle/product_detail_page?catid=149013&itemid=5268403792&shopid=33206500&similar_product_limit=24&similar_product_offset=0'
	},

	

	// 币种转换

	gerCurrency(){
		const params=[{
			label:'越南盾 D.',
			value:'VND',
			desc:'VN'
		},{
			label:'印尼盾 Rps.',
			value:'IDR',
			desc:'ID'
		},{
			label:'泰铢 Thai Baht',
			value:'THP',
			desc:'TH'
		},{
			label:'马币 M.',
			value:'MYR',
			desc:'MY'
		},{
			label:'菲律宾比索 P.',
			value:'PHP',
			desc:'PH'
		},{
			label:'人民币￥',
			value:'CNY',
			desc:'CH'
		},{
			label:'新加坡元',
			value:'$',
			desc:'SG'
		},{
			label:'台币',
			value:'NT',
			desc:'TW'
		},{
			label:'人民币',
			value:'rmb',
			desc:'CN'
		}]

		return params
	},



	unikvufm(list,name){
		let obj={}
		let arr=[]
		list.forEach(p => {
			if(!obj.name){
				arr.push(p)
				obj.name=p.orderId
			}
		})

		ret

	},
	//获取用户的附加属性
	getUserAtt(payload){
		const p = new Promise((resolve) => {
			newOrdersApi
			.getUserAttribute(payload)
			.then(res => {
			if(res.code === 200 ){
			
			resolve(res.data)
			
			}else{
			this.$message.warning(res.msg)
			}
			})
		})

		return p

	},
	//储存用户的附加属性
	settUserAtt(payload){
		newOrdersApi
		.updateUserAttribute(payload)
		.then(res => {
		if(res.code === 200 ){
		console.log('desc',res.data)
		}else{
		this.$message.warning(res.msg)
		}
		})

	},

	//判断是否是分销仓
	isDistributionStroe(id){
		let storeOptions=JSON.parse(localStorage.getItem('userInfo')).stores.filter(p => {
			if(p.isUsed) {
				return p
			}
		})
		let ttp=false
		if(storeOptions){
			ttp=storeOptions.find(item => item.storeId == id) ? storeOptions.find(item => item.storeId == id).storeType == 4 ? true : false :false
		}

		return ttp
	},
	jvkjfnmd(num){
		const params={
			'0':i18n.t("other.a1893"),
			'1':i18n.t("other.a3258"),
			'2':i18n.t("other.a1895"),
			'3':i18n.t("other.a1896"),
			'4':i18n.t("other.a1897"),
		}
		let ttp=params[num] ? params[num] : num
		return ttp
	},
	getCountryOption(id){
		const params=[
		// 	{
		// 	label:i18n.t('chat.Thailand'),
		// 	value:'TH',
		// },{
		// 	label:i18n.t('h5.DSX_index_my'),
		// 	value:'MY',
		// },{
		// 	label:i18n.t('h5.DSX_index_ph'),
		// 	value:'PH',
		// },{
		// 	label:i18n.t('h5.DSX_index_bz'),
		// 	value:'BZ'
		// },{
		// 	label:i18n.t('h5.DSX_index_vn'),
		// 	value:'VN',
		// },{
		// 	label:i18n.t('chat.Singapore'),
		// 	value:'SG',
		// },{
		// 	label:i18n.t('h5.DSX_index_tw'),
		// 	value:'TW'
		// },{
		// 	label:i18n.t('chat.Indonesia'),
		// 	value:'ID',
		// },
		{
			label:i18n.t('other.a2335'),
			value:'CN'
		},{
			label:i18n.t('other.a3337'),
			value:'0'
		}
		// ,{
		// 	label:i18n.t('other.a3338'),
		// 	value:'1'
		// },{
		// 	label:i18n.t('other.a3339'),
		// 	value:'2'
		// },{
		// 	label:i18n.t('other.a3340'),
		// 	value:'3'
		// },{
		// 	label:i18n.t('other.a3341'),
		// 	value:'4'
		// },{
		// 	label:i18n.t('other.a3342'),
		// 	value:'5'
		// },
	]
		return params
	},
	//判断当前卖家用户有多少个地区国家的店铺，return 国有代码
	getCountryCodeByUser(){
		let shopee=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
		let lazada=JSON.parse(localStorage.getItem('userInfo')).lazadaShops
		let temuAuth=JSON.parse(localStorage.getItem('userInfo')).temuAuth
		let obj={}
		let list=[]
		if(shopee){
			shopee.forEach(p => {
				p.country=p.country.toUpperCase()
				if(!obj[p.country]){
					list.push(p.country)
					obj[p.country]=true
				}
			})
		}
		if(lazada){
			lazada.forEach(p => {
				p.country=p.country.toUpperCase()
				if(!obj[p.country]){
					list.push(p.country)
					obj[p.country]=true
				}
			})
		}
		if(temuAuth){
			temuAuth.forEach(p => {
				if(!obj[p.shopSite]){
					list.push(p.shopSite)
					obj[p.shopSite]=true
				}
			})
		}
		return list

	},
	// 测品仓根据ID获取货物类型
	getChargeRuleBystoreId(id){
		let storeInfo=JSON.parse(localStorage.getItem('userInfo')).stores.find(p => p.storeId ==id)
		console.log('storeInfo',storeInfo)
		let list=[]
		if(storeInfo.chargeRule ){
			list=storeInfo.chargeRule.goodsChargeList.map(p => {
				return {
					label:p.goodsDesc,
					value:p.goodsType,
				}
			})
		}
		console.log(list)
		return list
	},

	printRecord(num){
		const params={
			'0':i18n.t("storePending.PrintPacklist"),
			'1':i18n.t("storePending.PrintPicklist"),
			'2':i18n.t("storePending.PrintShipingLabel"),
			'3':i18n.t("other.a3259"),
		}

		return params[num]
	},

	//判断是否是测品仓
	judgeTestStore(id){
		let storeOptions=JSON.parse(localStorage.getItem('userInfo')).stores.filter(p => {
			return p
		})

		let obj=storeOptions.find(item => item.storeId == id)

		return obj ? obj.storeType == 0 ? true : false :false
	},


	showStoreName(id){
		let stores=JSON.parse(localStorage.getItem('userInfo')).stores
		let ttp=null
		if(stores){
			stores.forEach(p => {
				if(p.storeId == id){
					ttp=p.storeName
				}
			})
		}

		return ttp ? ttp : i18n.t("other.a354")
	},
	
	setDefalultStoreId(id){
		localStorage.setItem('userStoreId',id)
		console.log('id',id)
	},

	getDefalultStoreId(){
		let storeId=localStorage.getItem('userStoreId')
		let ttp=null
		if(storeId){
			ttp=storeId
		}
		return  ttp
	},

	defaultStoreId(){
		let list=JSON.parse(localStorage.getItem('userInfo')).stores.filter(p => {
			if(p.isUsed){
				return p
			}
		})
		let storeId=localStorage.getItem('userStoreId')
		let ttp=null
		if(storeId){
			ttp=list.find(item => item.storeId == Number(storeId))
		}
		return  ttp ? ttp.storeId : list[0].storeId
	},
	conversionItemId(itemkey){
		let list=itemkey.split('|')
		let list2=list[1].split('_')
		return list2[0]
	},
	
	CurdateAddoneday(id){
		let time=new Date(id)
		time=time.setDate(time.getDate()+1)
		time=new Date(time)
		  var Y = time.getFullYear()
		  var M = time.getMonth() + 1
		  var D = time.getDate()
		  time = Y + (M < 10 ? "-0" : "-") + M + (D < 10 ? "-0" : "-") + D
		 return time
	},

	getShopeeAndLazadaShopInfo(flag=false){
		let shopee=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
		let lazada=JSON.parse(localStorage.getItem('userInfo')).lazadaShops
		let list=[]

		if(shopee){

			shopee.forEach(p => {
				list.push({
					value:p.shopId,
					label:p.shopName
				})
			})
		}

		if(lazada){

			lazada.forEach(p => {
				list.push({
					value:p.sellerId,
					label:p.name
				})
			})
		}

		


		
		return list
		
	},


	shopeeAndLazada(id,flag=false){
		let shopee=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
		let lazada=JSON.parse(localStorage.getItem('userInfo')).lazadaShops
		let list=[]

		if(shopee){
			shopee.forEach(p => {
				list.push({
					value:p.shopId,
					label:p.shopName
				})
			})
		}
		if(lazada){

			lazada.forEach(p => {
				list.push({
					value:p.sellerId,
					label:p.name
				})
			})
		}

		if(flag){
			list.push({
				value:JSON.parse(localStorage.getItem('userInfo')).id,
				label:JSON.parse(localStorage.getItem('userInfo')).userId
			})
		}
		let ttp=null
		if(id == 'all'){
			ttp=i18n.t("other.a358")
		}else{

			list.forEach(p => {
				if(p.value === id){
					ttp=p.label
				}
			})
		}
		
		
		return ttp
		
	},
	//根据仓库ID匹配仓库名
	MatchStoreNameAccorderStoreId(id){
		let stores=JSON.parse(localStorage.getItem('userInfo')).stores
	
		let list=[]
		stores.forEach(p => {
			list.push({
				value:p.storeId,
				label:p.storeName
			})
		})
		
		let ttp=null
		if(id == 'all'){
			ttp=i18n.t("other.a358")
		}else{

			list.forEach(p => {
				if(p.value === id){
					ttp=p.label
				}
			})
		}
		
		
		return ttp
		
	},
	conutryConversion(id){
		const obj={
			'TH':i18n.t("h5.DSX_index_th"),
			'PH':i18n.t("h5.DSX_index_ph"),
			'VN':i18n.t("h5.DSX_index_vn"),
			'MY':i18n.t("other.a1092"),
			'TW':i18n.t("h5.DSX_index_tw"),
			'ID':i18n.t("h5.DSX_index_id"),
			'BR':i18n.t("h5.DSX_index_bz"),
			'0':i18n.t("other.a3337"),
			'1':i18n.t("other.a3338"),
			'2':i18n.t("other.a3339"),
			'3':i18n.t("other.a3340"),
			'4':i18n.t("other.a3341"),
			'5':i18n.t("other.a3342"),
		}
		
		return obj[id] ? obj[id] : id
	},

	conutryConversionCopy(id){
		const obj={
			'TH':1,
			'PH':2,
			'VN':3,
			'MY':4,
			'TW':5,
			'ID':6,
			
		}

		return obj[id]
	},
   /**
   * 拼接图片链接
   */
	// getImageUrl: function(url, image) {
	// 	let host = url.substring(8, url.indexOf('/', 8))
	// 	let platform = ''
	// 	switch (host) {
	// 	  // 印尼
	// 	  case 'shopee.co.id':
	// 	  case 'id.xiapibuy.com':
	// 		platform = 'https://s-cf-id.shopeesz.com/file/'
	// 		break
	// 	  // 马来
	// 	  case 'shopee.com.my':
	// 	  case 'my.xiapibuy.com':
	// 		platform = 'https://s-cf-my.shopeesz.com/file/'
	// 		break
	// 	  // i18n.t("h5.DSX_index_th")
	// 	  case 'shopee.co.th':
	// 	  case 'th.xiapibuy.com':
	// 		platform = 'https://s-cf-th.shopeesz.com/file/'
	// 		break
	// 	  // 菲律宾
	// 	  case 'ph.xiapibuy.com':
	// 	  case 'shopee.ph':
	// 		platform = 'https://s-cf-ph.shopeesz.com/file/'
	// 		break
	// 	  // 新加坡
	// 	  case 'sg.xiapibuy.com':
	// 	  case 'shopee.sg':
	// 		platform = 'https://s-cf-sg.shopeesz.com/file/'
	// 		break
	// 	  // 越南
	// 	  case 'vn.xiapibuy.com':
	// 	  case 'shopee.vn':
	// 		platform = 'https://s-cf-vn.shopeesz.com/file/'
	// 		break
	// 	  // 台湾
	// 	  case 'xiapi.xiapibuy.com':
	// 	  case 'shopee.tw':
	// 	  case 'www.shopee.tw':
	// 		platform = 'https://s-cf-tw.shopeesz.com/file/'
	// 		break
	// 	  // 巴西
	// 	  case 'shopee.com.br':
	// 	  case 'br.xiapibuy.com':
	// 		platform = 'https://s-cf-br.shopeesz.com/file/'
	// 		break
	// 	  default:
	// 		platform = ''
	// 	}
	// 	return platform + image
	//   },
	//判断isUsed是否为true,获取用户所有的storeId
	getAllstorIdsByisUsedForTrue(){
		let stores=JSON.parse(localStorage.getItem('userInfo')).stores
		let storeIds=[]
		stores.forEach(p => {
			if(p.isUsed){
				storeIds.push(p.storeId)
			}
		})

		return storeIds
	},
	//判断isUsed是否为true,获取用户所有的仓库选项，下拉框使用
	getStoreOptions(){
		let stores=JSON.parse(localStorage.getItem('userInfo')).stores
		let storeIds=[]
		if(stores){
			stores.forEach(p => {
				if(p.isUsed){
					storeIds.push({
						label:p.storeName,
						value:p.storeId
					})
				}
			})
		}

		return storeIds
	},
	//筛选框，获取里面的options
	getStoresByStoreType(id){
		let stores=JSON.parse(localStorage.getItem('userInfo')).stores
		let options=[]
		if(id){
			stores.forEach(p => {
				if(p.storeType == id && p.isUsed){
					options.push({
						label:p.storeName,
						value:p.storeId,
						country:p.storeAddress
					})
				}
			})
		}else{
			stores.forEach(p => {
				if(p.isUsed){
					options.push({
						label:p.storeName,
						value:p.storeId,
						country:p.storeAddress
					})
				}
			})
		}

		return options
	},

	//数组对象去重

	deDuplication(arr,key){
		let desc=key 
		let obj1 = {};
		let res1 = [];
		arr.forEach(k => {
			if(!obj1[k.desc]){
				res1.push(k)
				obj1[k.desc]=true
			}
		})

		return res1

	},

	getGoodsType(){
		const options=[{
			value: 0,
			label: i18n.t("other.a2245")
		},
		{
			value: 1,
			label: i18n.t("other.a2243")
		},
		{
			value: 2,
			label: i18n.t("other.a2244")
		},
		{
			value: 3,
			label: i18n.t("other.a2248")
		},
		{
			value: 4,
			label: i18n.t("other.a2246")
		},
		{
			value: 5,
			label: i18n.t("other.a2247")
		}
	]
		return options
		
	},
	goodsType(code ){
		const options={
			0:i18n.t("other.a2243"),
			1:i18n.t("other.a2244"),
			2:i18n.t("other.a2245"),
			3:i18n.t("other.a2246"),
			4:i18n.t("other.a2247"),
			5:i18n.t("other.a2248")
			
		}
		return options[code]
		
	},

	cleanStorageData(){
		localStorage.removeItem('tableList')
		localStorage.removeItem('picklist')
		localStorage.removeItem('picklistInfo')
		localStorage.removeItem('printcontent')
		localStorage.removeItem('purchaseItems')
		localStorage.removeItem('storeItemDetail')
		
	},
	//仓库帐号下，获取与之绑定的所有卖家
	getSellerBystoreId(){
		let options=[]
		let sellers=JSON.parse(localStorage.getItem('userInfo')).sellers
		if(sellers){
			sellers.forEach(p => {
				options.push({
					label:p.userName,
					value:p.userId
				})
			})
		}
		return options
	},
	//lazada匹配仓库名称  286652887-blackmore
	lazadashowstoreNameBystoreId(id){
		let obj= new Object();
		let shopList=this.getAllwarehouseLazada().slice(1)
		shopList.forEach((p,index) => {
			obj[shopList[index].value]=p.label
			
		})
		return obj
	},
	//lazada匹配店铺名称  286652887-blackmore
	lazadashowshopNameByshopId(id){
		let obj= new Object();
		let shopList=this.getAllshopLazada().slice(1)
		shopList.forEach((p,index) => {
			obj[shopList[index].value]=p.label
			
		})
		return obj
	},
	//匹配仓库名称  286652887-blackmore
	showstoreNameBystoreId(id){

		let warehouseList=JSON.parse(localStorage.getItem('userInfo')) .stores
		let obj= new Object();
		warehouseList.forEach((p,index) => {
			if(p.storeId === id){
				obj=p
			}
			
		})
		return obj.storeName 
	},
	//匹配店铺名称  286652887-blackmore
	showshopNameByshopId(id){
		let obj= new Object();
		let shopList=this.getAllshop().slice(1)
		shopList.forEach((p,index) => {
			obj[shopList[index].value]=p.label
		})
		return obj
	},

	//匹配店铺名称  286652887-blackmore
	showshopNameByshopIdOne(id){
		let obj= new Object();
		let shopList=this.getAllshop().slice(1)
		shopList.forEach((p,index) => {
			obj[shopList[index].value]=p.label
			
		})
		return obj[id]
	},
	//数组去重
	unique(arr){            
	        for(var i=0; i<arr.length; i++){
	            for(var j=i+1; j<arr.length; j++){
	                if(arr[i]==arr[j]){         //第一个等同于第二个，splice方法删除第二个
	                    arr.splice(j,1);
	                    j--;
	                }
	            }
	        }
	return arr;
	},
	
	addDays(date, days,seperator='-') {
	  let oDate = new Date(date).valueOf();
	  let nDate = oDate + days * 24 * 3600 * 1000;
	  nDate = new Date(nDate);
	  let y = nDate.getFullYear().toString().padStart(2, 0);
	  let m = (nDate.getMonth() + 1).toString().padStart(2, 0);
	  let d = nDate.getDate().toString().padStart(2, 0);
	  return `${y}${seperator}${m}${seperator}${d}`
	},
	// 将中国标准时间,转化为正确的时间格式
	getCurrnetTime(dateData){
	  var date = new Date(dateData)
	      var y = date.getFullYear()
	      var m = date.getMonth() + 1
	      m = m < 10 ? ('0' + m) : m
	      var d = date.getDate()
	      d = d < 10 ? ('0' + d) : d
		  var h = date.getHours()
		  h = h < 10 ? ('0' + h) : h
		  var i = date.getMinutes()
		  i = i < 10 ? ('0' + i) : i
		  var s = date.getSeconds()
		  s = s < 10 ? ('0' + s) : s
	      const time = y + '-' + m + '-' + d + ' ' + h+ ':' + i +":" +s
	      return time

	},
	getAllstoreExpect(id){
		let options=[]
		let warehouseList=[]
		console.log('id',id)
		
		if(id == null || id == undefined){
			warehouseList=JSON.parse(localStorage.getItem('userInfo')).stores.filter(p => {
				if(p.isUsed){
					return p
				}
			})
			
		}else{
			warehouseList=JSON.parse(localStorage.getItem('userInfo')).stores.filter(p => {
				if(p.isUsed && p.storeType !==id){
					return p
				}
			})
		}

		options=warehouseList.map(p => {
			return {
				value:p.storeId,
				label:p.storeName
			}
		})

		return options

	},

	getAllstoreExpectCopy(){
		let options=[]
		let warehouseList=[]
	
	
		warehouseList=JSON.parse(localStorage.getItem('userInfo')).stores.filter(p => {
			if(p.isUsed){
				return p
			}
		})
			
		

		options=warehouseList.map(p => {
			return {
				value:p.storeId,
				label:p.storeName
			}
		})

		return options

	},
	//全部仓库shopee "(" + item.userName + ")"
	getAllwarehouse(){
		let options=[]
		let userPos=JSON.parse(localStorage.getItem('userInfo')).userPos
		let warehouseList=JSON.parse(localStorage.getItem('userInfo')).stores
		console.log('warehouseList',warehouseList)
		if(warehouseList == [] ||  warehouseList == null) {
			return [{
				value: -1,
				label:i18n.t("other.a3260"),
			}]
		}
		warehouseList.forEach(item => {

			if(userPos == 'SELLER'){
				if(item.isUsed){
					options.push({
						value:item.storeId,
						label:item.storeName 
					})
				}
			}

			if(userPos == 'STORE'){
					options.push({
						value:item.storeId,
						label:item.storeName 
					})
				
			}

			
		
			
		})
		options.unshift({
			value: '',
			label: i18n.t('userStoreItems').all,
		})
		// options[1].isActive='active'

		console.log('11',options)
		return options
		
		
		
	},
	//lazada全部商店筛选框
	getAllshopLazada(){
		const shopList=JSON.parse(localStorage.getItem('lazadashopId')) || ''
		if(!shopList.length) {
			return  
		}
		
		let ttp=shopList.map(item => {
			return {
				value: item.sellerId,
				label: item.name,
			}
		})
		ttp.unshift({
			value: '',
			label: i18n.t('binditems').allShop,
		})
	
		return ttp
		
	},
	//lazada全部仓库筛选框
	getAllwarehouseLazada(){
		const shopList=JSON.parse(localStorage.getItem('warehouse'))
		let ttp=shopList.map(item => {
			return {
				value: item.storeId,
				label: item.storeName,
			}
		})
		ttp.unshift({
			value: '',
			label: i18n.t('userStoreItems').all,
		})
	
		return ttp
	},
	//只获取tiktok店铺信息
	onlyGetTikTokshop(){
		let tiktokShops=JSON.parse(localStorage.getItem('userInfo')).tiktokShops
		let shopList=[]
		if(tiktokShops){
			tiktokShops.forEach(p => {
				shopList.push({
					value:p.shopId,
					label:p.shopName,
					active:false
				})
			})
		}

		return shopList ? shopList : []
	},
	//只获取temu店铺信息
	onlyGetTEMUshop(){
		let temuAuth=JSON.parse(localStorage.getItem('userInfo')).temuAuth
		let shopList=[]
		if(temuAuth){
			temuAuth.forEach(p => {
				shopList.push({
					value:p.shopId,
					label:p.shopName,
					active:false
				})
			})
		}

		return shopList ? shopList : []
	},
	conversionCountryName(code){
		const country={
			'TH':i18n.t("h5.DSX_index_th"),
			'SG':i18n.t("other.a2232"),
			'PH':i18n.t("h5.DSX_index_ph"),
			'MY':i18n.t("h5.DSX_index_my"),
			'ID':i18n.t("h5.DSX_index_id"),
			'VN':i18n.t("h5.DSX_index_vn"),
			'CN':i18n.t("other.a2335"),
			'TW':i18n.t("h5.DSX_index_tw"),
		}
		
		return country[code]
	},
	//只获取lazada店铺信息
	onlyGetLAZADAshop(){
		let lazada=JSON.parse(localStorage.getItem('userInfo')).lazadaShops
		let shopList=[]
		if(lazada){
			lazada.forEach(p => {
				shopList.push({
					value:p.sellerId,
					label:p.name,
					active:false
				})
			})
		}

		return shopList ? shopList : []
	},
	//只获取shopee店铺信息
	onlyGetShopeeshop(){
		let shopeeShops=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
		let shopList=[]
		if(shopeeShops){
			shopeeShops.forEach(p => {
				shopList.push({
					value:p.shopId,
					label:p.shopName,
					active:false
				})
			})
		}

		return shopList ? shopList : []
	},
	//shopee全部商店筛选框
	getAllshop(){
		let shopee=JSON.parse(localStorage.getItem('userInfo')).shopeeShops
		let lazada=JSON.parse(localStorage.getItem('userInfo')).lazadaShops
		let tiktopShops=JSON.parse(localStorage.getItem('userInfo')).tiktokShops
		let temuAuth=JSON.parse(localStorage.getItem('userInfo')).temuAuth
		let shopList=[]
		if(shopee){
			shopee.forEach(p => {
				shopList.push({
					shopId:p.shopId,
					shopName:p.shopName,
					country:p.country
				})
			})
		}
		if(lazada){
			lazada.forEach(p => {
				shopList.push({
					shopId:p.sellerId,
					shopName:p.name,
					country:p.country
				})
			})
		}
		if(tiktopShops){
			tiktopShops.forEach(p => {
				shopList.push({
					shopId:p.shopId,
					shopName:p.shopName,
					country:p.region
				})
			})
		}
		if(temuAuth){
			temuAuth.forEach(p => {
				shopList.push({
					shopId:p.shopId,
					shopName:p.shopName,
					country:p.region
				})
			})
		}
		
	
		if(shopList !== null){
			let ttp=shopList.map(item => {
				return {
					value: item.shopId,
					label: item.shopName,
					city : item.country,
					isActive:'',
				}
			})
			ttp.unshift({
				value: '',
				label: i18n.t('binditems').allShop,
				isActive:'',
				city : '',
			})
			// ttp[1].isActive='active'
			return ttp
		}else{
			
			return [{
				value: -1,
				label:i18n.t("other.a3261"),
			}]
		}

	
		
		
	},
	// 筛选订单的所有状态
	getOrderStatus(){
		const arr=[{
			  value: 0,
			  label: i18n.t('aside').allOrder
			},{
			  value: 1,
			  label: i18n.t('pendingorder').UNAUDIT
			},{
			  value: 3,
			  label: i18n.t('unprocessedorder').tobegenerated
			},{
				value: 4,
				label: i18n.t('unprocessedorder').tobeprinted
			},{
			  value: 5,
			  label: i18n.t('unprocessedorder').printed
			},
			{
			  value: 6,
			  label: i18n.t('shippedorder').shipped
			},
			
			]
		return arr
		
	},
	//2020-11-13T03:24:30.000+0000时间格式转换,相差8小时的转换方法
	renderTime(date) {
		if(date){
			var dateee = new Date(date).toJSON();
			return new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '') 

		}else{
			return i18n.t("other.a354")
		}
	},
	
	//2020-11-13T03:24:30.000+0000时间格式转换,相差8小时的转换方法---只留下日期
	renderTimeDate(date) {
	  var dateee = new Date(date).toJSON();
	 let flag= new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '') 
	 let  ttp=flag.split(' ')
	  return  ttp[0]
	},


	//2020-11-13T03:24:30.000+0000时间格式转换,相差8小时的转换方法---只留下日期
	renderTimeDateCopy(date) {
		var dateee = new Date(date).toJSON();
	   let flag= new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '') 
	   let num=flag.indexOf(':')
	   let  ttp=flag.split(' ')
		return  ttp[0]
	  },
	//倒计时
	countTimeCopy(time){
			if(!time){
				return i18n.t("other.a354")
			}

			var dateee = new Date(time).toJSON();
	 

			let lasttime=new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '') 
		   
			let day=''
			let hour=''
			let minute=''
			let second=''
			const end = Date.parse(new Date(lasttime))
			const now = Date.parse(new Date())
			
			if (now >= end) {
			   day = 0
			   hour = 0
			   minute = 0
			   second = 0
			   return "0"
			}
			
			const msec = end - now
			let d = parseInt(msec / 1000 / 60 / 60 / 24) //算出天数
			let h = parseInt(msec / 1000 / 60 / 60 % 24)//算出小时数
			let m = parseInt(msec / 1000 / 60 % 60)//算出分钟数
			let s = parseInt(msec / 1000 % 60)//算出秒数
		   
			day = d
			hour = h > 9 ? h : '0' + h
			minute = m > 9 ? m : '0' + m
			second = s > 9 ? s : '0' + s
			const that = this
			
			return day + this.$t('pendingorder.day') + hour+ this.$t('pendingorder.hours') + minute +i18n.t("pendingorder.min")
					
				   
   },
	//获取现在的时间
	setNowTimes (atp){
		let myDate = atp
		    // console.log(myDate)
		    let wk = myDate.getDay()
		    let yy = String(myDate.getFullYear())
		    let mmp = myDate.getMonth() + 1
			let mm = String(mmp < 10 ? '0' + mmp : mmp) 
		    let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
		    let hou = String(myDate.getHours() < 10 ? '0' + myDate.getHours() : myDate.getHours())
		    let min = String(myDate.getMinutes() < 10 ? '0' + myDate.getMinutes() : myDate.getMinutes())
		    let sec = String(myDate.getSeconds() < 10 ? '0' + myDate.getSeconds() : myDate.getSeconds())
		    let weeks = [i18n.t("chat.Sunday"), i18n.t("chat.Monday"), i18n.t("chat.Tuesday"), i18n.t("chat.Wednesday"), i18n.t("chat.Thursday"), i18n.t("chat.Friday"), i18n.t("chat.Saturday")]
		    let week = weeks[wk]
		    let nowDate = yy + '-' + mm + '-' + dd
		    let nowTime = hou + ':' + min + ':' + sec
		    let nowWeek = week
		    let ccp = nowDate + ' ' + nowTime + ' ' + nowWeek
			return  ccp.substring(0,11)
	},


	//获取当前时间
	getNowTime(){
		let time=new Date()
		let timeCopy=this.getCurrnetTime(time)
		 return timeCopy
		
	},
	
	getRecentDays(day) {
		var today = new Date();
		var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
		today.setTime(targetday_milliseconds); //注意，这行是关键代码
		var tYear = today.getFullYear();
		var tMonth = today.getMonth();
		var tDate = today.getDate();
		tMonth = this.doHandleMonth(tMonth + 1);
		tDate = this.doHandleMonth(tDate);
		return tYear + "-" + tMonth + "-" + tDate;
	},
	
	formatDate(date,desc) {
	  var date = new Date(date);
	  var YY = date.getFullYear() + '-';
	  var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
	  var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
	  var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
	  var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
	  var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
	  if(desc){
		    return YY + MM + DD + ' ' +desc
	  }else{
		   return YY + MM + DD 
	  }
	 
	},
	
	getTime01(time) {
		if (!time) {
			return i18n.t("other.a354")
		}
		let ttp = time.slice(0, time.indexOf('T'))
		let ccp = time.slice(time.indexOf('T') + 1, time.indexOf('.'))
		return ttp 
	
	},

	download(pickData,fields){
		
		try {
			const result = json2csv.parse(pickData, {
				fields: fields,
				excelStrings: true
			});
			if (this.MyBrowserIsIE()) {
				// IE10以及Edge浏览器
				var BOM = "\uFEFF";
								// 文件转Blob格式
				var csvData = new Blob([BOM + result], { type: "text/csv" });
				navigator.msSaveBlob(csvData, `picklist.csv`);
			} else {
				let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
				// 非ie 浏览器
				this.createDownLoadClick(csvContent, `picklist.csv`);
			}
		} catch (err) {
			alert(err);
		}
	},

	//创建a标签下载
	createDownLoadClick(content, fileName) {
		const link = document.createElement("a");
		link.href = encodeURI(content);
		link.download = fileName;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	},

	// 判断是否IE浏览器
	MyBrowserIsIE() {
		let isIE = false;
		if (
			navigator.userAgent.indexOf("compatible") > -1 &&
			navigator.userAgent.indexOf("MSIE") > -1
		) {
			// ie浏览器
			isIE = true;
		}
		if (navigator.userAgent.indexOf("Trident") > -1) {
			// edge 浏览器
			isIE = true;
		}
		return isIE;
	},
	
	//导出为EXCEL
	exportExcel(tableData) {
	  require.ensure([], () => {
		const { export_json_to_excel } = require('../vendor/Export2Excel.js');
		const tHeader = ['订单号','运单号','付款方式','买家总付款','国家','省','市','详细地址','邮编','产品名称','属性SKU','商品Sku','数量','单价','快递方式','收件人电话','收件人','下单时间'];
		// 上面设置Excel的表格第一行的标题
		const filterVal = ['订单号','运单号','付款方式','买家总付款','国家','省','市','详细地址','邮编','产品名称','属性SKU','商品Sku','数量','单价','快递方式','收件人电话','收件人','下单时间'];
		// 上面的index、nickName、name是tableData里对象的属性
		const list = tableData;  //把data里的tableData存到list
		const data = this.formatJson(filterVal, list);
		export_json_to_excel(tHeader, data, 'picklist');
	  })
	},
	
	//已处理订单导出
	exportProcessedOrder(tableData) {
		console.log('hjdkj',tableData)
	  require.ensure([], () => {
		const { export_json_to_excel } = require('../vendor/Export2Excel.js');
		const tHeader = ['支付类型','支付单号','支付积分','积分变化前','积分变化后','收款方','付款方', '时间'];
		// 上面设置Excel的表格第一行的标题
		const filterVal = ['支付类型','支付单号','支付积分','积分变化前','积分变化后','收款方','付款方', '时间'];
		// 上面的index、nickName、name是tableData里对象的属性
		const list = tableData;  //把data里的tableData存到list
		const data = this.formatJson(filterVal, list);
		export_json_to_excel(tHeader, data, 'picklist');
	  })
	},

	exPortEXml(tableData,arr,name) {
	console.log(tableData)
	  require.ensure([], () => {
		console.log("===1")
		const { export_json_to_excel } = require('../vendor/Export2Excel.js');
		const tHeader = arr
		// 上面设置Excel的表格第一行的标题
		const filterVal =arr
		console.log("===2")
		// 上面的index、nickName、name是tableData里对象的属性
		const list = tableData;  //把data里的tableData存到list
		const data = this.formatJson(filterVal, list);
		export_json_to_excel(tHeader, data, name);
		console.log("===3")
	  })
	},
	
	//导出全部库存
	exportStore(tableData) {
		console.log('hjdkj',tableData)
	  require.ensure([], () => {
		const { export_json_to_excel } = require('../vendor/Export2Excel.js');
		const tHeader = ['cusCode','itemId','variationId','itemName','skuName','storeNum','unShipped', 'stock','packageLength','packageWidth','packageHeight','weight','shopId','shopName'];
		// 上面设置Excel的表格第一行的标题
		const filterVal = ['cusCode','itemId','variationId','itemName','skuName','storeNum','unShipped', 'stock','packageLength','packageWidth','packageHeight','weight','shopId','shopName'];
		// 上面的index、nickName、name是tableData里对象的属性
		const list = tableData;  //把data里的tableData存到list
		const data = this.formatJson(filterVal, list);
		export_json_to_excel(tHeader, data, 'storelist');
	  })
	},
	
	
	//导出为EXCEL
	exportExcel_Claim(tableData) {
	  require.ensure([], () => {
		const { export_json_to_excel } = require('../vendor/Export2Excel.js');
		const tHeader = ['订单号','退货原因','金额','下单时间','状态'];
		// 上面设置Excel的表格第一行的标题
		const filterVal = ['订单号','退货原因','金额','下单时间','状态'];
		// 上面的index、nickName、name是tableData里对象的属性
		const list = tableData;  //把data里的tableData存到list
		const data = this.formatJson(filterVal, list);
		export_json_to_excel(tHeader, data, 'claimlist');
	  })
	},
	

	//导出缺货提醒
	exportExcel_quehuo(tableData) {
	  require.ensure([], () => {
		const { export_json_to_excel } = require('../vendor/Export2Excel.js');
		const tHeader = ['店铺名称','商品名称','sku','建议采购数','现有数量','在途数量','平均销量/天','补货周期'];
		// 上面设置Excel的表格第一行的标题
		const filterVal = ['店铺名称','商品名称','sku','建议采购数','现有数量','在途数量','平均销量/天','补货周期'];
		// 上面的index、nickName、name是tableData里对象的属性
		const list = tableData;  //把data里的tableData存到list
		const data = this.formatJson(filterVal, list);
		export_json_to_excel(tHeader, data, 'claimlist');
	  })
	},
		
	formatJson(filterVal, jsonData) {
	  return jsonData.map(v => filterVal.map(j => v[j]));
	},

	/**
	 * [isDuringDate 比较当前时间是否在指定日期范围内]
	 * @DateTime 2019-08-21
	 * @param    date   [beginDateStr] [开始日期]
	 * @param    date   [endDateStr]   [结束日期]
	 * @return   Boolean
	 */
    isDuringDate: function (beginDateStr, endDateStr) {
        var curDate = new Date(),
            beginDate = new Date(beginDateStr),
            endDate = new Date(endDateStr);
        if (curDate >= beginDate && curDate <= endDate) {
            return true;
        }
        return false;
    },

	
	
	//订单状态转换
	conversionStatus(item){
		let flag=''
		switch(item.orderType){
			case 0:
			flag=i18n.$t('other.a147')
			break;

			case 1:
			flag=i18n.t("other.a848")
			break;

			case 2:
			flag=i18n.t("allorders.insanity")
			break;
			case 3:
			flag=i18n.t("allorders.insanity")
			break;
			case 4:
			flag=i18n.t("allorders.insanity")
			break;

			case 9:
			flag=i18n.t("other.a840")
			break;

			case 8:
			flag=i18n.t("other.a842")
			break;

			case 7:
			flag=i18n.t("homeTwo.Buyerhasconfirmed")
			break;
			case 5:
			flag=i18n.t("homeTwo.Courierhasbeencollected")
			break;
			case 6:
			flag=i18n.t("homeTwo.Courierhasbeendelivered")
			break;


		}

		return flag
	},
	
	//系统自动取消订单时间
	cancelOrderTime(paytime,shiptime){
					 if(!paytime) {
						 return i18n.t("unprocessedorder.pending_upgrade")
					 }else{
						 let day=''
						 let hour=''
						 let minute=''
						 let second=''
						 let ttp=paytime.slice(0,paytime.indexOf('T')) //2020-12-12
									  let oop=shiptime  //16天 
									 let bbp=new Date(ttp.replace('-','/'))
									 let t=bbp.getTime() + oop * 24 * 3600 * 1000;
						 let ccp=paytime.slice(paytime.indexOf('T')+1,paytime.indexOf('.'))  //13:52:24
						let u=new Date(t)
									let g=u.getFullYear() + '-' + (u.getMonth() + 1) + '-' + u.getDate() //累加后的时间
						 let mmp = oop > 9 ? oop : '0' + oop
						 let mmo=ttp.slice(0,8) + mmp
						 let currentime=ttp+ ' ' +ccp
						 let lasttime=g + ' ' +ccp
									
									
					
						 const end = Date.parse(new Date(lasttime))
						 // 定义当前时间戳
						 const now = Date.parse(new Date())
						 // console.log(end)
						 // console.log(now)
						 // 做判断当倒计时结束时都为0
						 if (now >= end) {
						 	day = 0
						 	hour = 0
						 	minute = 0
						 	second = 0
						 	return
						 }
						 // 用结束时间减去当前时间获得倒计时时间戳
						 const msec = end - now
						 let d = parseInt(msec / 1000 / 60 / 60 / 24) //算出天数
						 let h = parseInt(msec / 1000 / 60 / 60 % 24)//算出小时数
						 let m = parseInt(msec / 1000 / 60 % 60)//算出分钟数
						 let s = parseInt(msec / 1000 % 60)//算出秒数
						 //给数据赋值
						 day = d
						 hour = h > 9 ? h : '0' + h
						 minute = m > 9 ? m : '0' + m
						 second = s > 9 ? s : '0' + s
						 //定义this指向
						 const that = this
						 // 使用定时器 然后使用递归 让每一次函数能调用自己达到倒计时效果
						 setTimeout(function () {
						 	that.countTime()
						 }, 1000)
						 
						 return day + i18n.t("other.a177") + hour+ i18n.t("pendingorder.hours")+ minute +i18n.t("pendingorder.min") 
					 }
					
	},
	
	//剩余发货时间
	countTime(time){
					
					 if(!time){
						 return i18n.t("other.a354")
					 }
						
						
						var dateee = new Date(time).toJSON();
						let lasttime=new Date(+new Date(dateee) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '') 
												
						let day=''
						let hour=''
						let minute=''
						let second=''
						const end = Date.parse(new Date(lasttime))
						const now = Date.parse(new Date())
						
						if (now >= end) {
													day = 0
													hour = 0
													minute = 0
													second = 0
													return "0"
						}
						
						const msec = end - now
						let d = parseInt(msec / 1000 / 60 / 60 / 24) //算出天数
						let h = parseInt(msec / 1000 / 60 / 60 % 24)//算出小时数
						let m = parseInt(msec / 1000 / 60 % 60)//算出分钟数
						let s = parseInt(msec / 1000 % 60)//算出秒数				
						day = d
						hour = h > 9 ? h : '0' + h
						minute = m > 9 ? m : '0' + m
						second = s > 9 ? s : '0' + s				
						const that = this
						 return day + i18n.t('pendingorder.day') + hour+ i18n.t('pendingorder.hours') + minute +i18n.t('pendingorder.min')
					 
					
	},
	
	//获取最近7天的时间 年-月-日 
	getRecentSevenDay(day) {
	      var today = new Date();
	      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
	      today.setTime(targetday_milliseconds); //注意，这行是关键代码
	      var tYear = today.getFullYear();
	      var tMonth = today.getMonth();
	      var tDate = today.getDate();
	      tMonth = this.doHandleMonth(tMonth + 1);
	      tDate = this.doHandleMonth(tDate);
	      return tYear + "-" + tMonth + "-" + tDate;
	    },
	    doHandleMonth(month) {
	      var m = month;
	      if (month.toString().length == 1) {
	        m = "0" + month;
	      }
	      return m;
	    },
	//获取最近7天的时间 年-月-日 时：分：秒
	getRecentSomeDays(day) {
		var today = new Date();
		var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
		today.setTime(targetday_milliseconds); //注意，这行是关键代码
		var tYear = today.getFullYear();
		var tMonth = today.getMonth();
		var tDate = today.getDate();
		var tHourse = today.getHours();
		var tMin = today.getMinutes();
		var tSec = today.getSeconds();
		tMonth = this.doHandleMonth(tMonth + 1);
		tDate = this.doHandleMonth(tDate);
		return tYear + "-" + tMonth + "-" + tDate + " " + tHourse + ":"  +  tMin  + ":" + tSec ;
	  },
	  doHandleMonth(month) {
		var m = month;
		if (month.toString().length == 1) {
		  m = "0" + month;
		}
		return m;
  },
	//
	 getLastWeek() {
		 console.log(123)
	    var now = new Date();
	    var year = now.getFullYear();
	    var month = now.getMonth() + 1;//0-11表示1-12月
	    var day = now.getDate();
	    var dateObj = {};
	    dateObj.now = year + '-' + month + '-' + day;
	    if(day - 7 <= 0){   //如果在当月7日之前
	        var lastMonthDay = new Date(year, (parseInt(month) - 1), 0).getDate();    //1周前所在月的总天数
	        if(month - 1 <= 0){ //如果在当年的1月份
	            dateObj.last = (year - 1) + '-' + 12 + '-' + (31 - (7 - day));
	        }else{
	            dateObj.last = year + '-' + (month - 1) + '-' + (lastMonthDay - (7 - day));
	        }
	    }else{
	        dateObj.last = year + '-' + month + '-' + (day -7);
	    }
	    return dateObj;
		console.log(dateObj)
	},
	
	
	
	getdate(date) {
		var year = date.getFullYear() - 1;
		var month =
			date.getMonth() + 1 < 10 ?
			"0" + (date.getMonth() + 1) :
			date.getMonth() + 1;
		var day =
			date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
		var hours =
			date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
		var minutes =
			date.getMinutes() < 10 ?
			"0" + date.getMinutes() :
			date.getMinutes();
		var seconds =
			date.getSeconds() < 10 ?
			"0" + date.getSeconds() :
			date.getSeconds();
		let time =
			year +
			"-" +
			month +
			"-" +
			day +
			" " +
			hours +
			":" +
			minutes +
			":" +
			seconds;
		return time 
	},
	
	
	getchinastadarTime(day){
	    var today = new Date();
	    var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
	    today.setTime(targetday_milliseconds); //注意，这行是关键代码
		// var tYear = today.getFullYear();
		// var tMonth = today.getMonth() + 1;
		// var tDate = today.getDate()< 10 ? "0" + today.getDate() : today.getDate();;
		// var thour=today.getHours() < 10 ? "0" + today.getHours() : today.getHours();
		// var tmin=today.getMinutes() < 10 ? "0" + today.getMinutes() : today.getMinutes();
		// var tseconds=today.getSeconds() < 10 ? "0" + today.getSeconds() : today.getSeconds();
	 //    console.log(tYear+"-"+tMonth+"-"+tDate+" "+thour+":"+tmin+":"+tseconds)    
	 //    return (tYear+"-"+tMonth+"-"+tDate+" "+thour+":"+tmin+":"+tseconds)
	      return today
	   },

	   judgePcOrAndirod(){
			var ttp =false
			var pda_user_agent_list = new Array("2.0 MMP", "240320", "AvantGo", "BlackBerry", "Blazer",
					"Cellphone", "Danger", "DoCoMo", "Elaine/3.0", "EudoraWeb", "hiptop", "IEMobile", "KYOCERA/WX310K", "LG/U990",
					"MIDP-2.0", "MMEF20", "MOT-V", "NetFront", "Newt", "Nintendo Wii", "Nitro", "Nokia",
					"Opera Mini", "Opera Mobi",
					"Palm", "Playstation Portable", "portalmmm", "Proxinet", "ProxiNet",
					"SHARP-TQ-GX10", "Small", "SonyEricsson", "Symbian OS", "SymbianOS", "TS21i-10", "UP.Browser", "UP.Link",
					"Windows CE", "WinWAP", "Android", "iPhone", "iPod", "iPad", "Windows Phone", "HTC"/*, "GTB"*/);
			var pda_app_name_list = new Array("Microsoft Pocket Internet Explorer");
			var user_agent = navigator.userAgent.toString();
			for (var i = 0; i < pda_user_agent_list.length; i++) {
				if (user_agent.indexOf(pda_user_agent_list[i]) >= 0) {
					return true;
				}
			}
			var appName = navigator.appName.toString();
			for (var i = 0; i < pda_app_name_list.length; i++) {
				if (user_agent.indexOf(pda_app_name_list[i]) >= 0) {
					ttp= true;
				}
			}
			return ttp
	   },

	   //积分变化名称option
	   chargeNameOptions(){
		let payTypeOptions=[
			{
				value: null,
				label: i18n.t("other.a113"),
				userPos:'all',
			},
			{
				value: 0,
				label: i18n.t("processed.wechat"),
				userPos:null,
			},
			{
				value: 1,
				label:i18n.t("processed.Wechatincome"),
				userPos:'seller',
			},
			{
				value: 2,
				label: i18n.t("processed.alipay")
			},
			{
				value: 3,
				label: i18n.t("processed.Alipayincome"),
				userPos:'seller',
			},
			{
				value: 4,
				label: i18n.t("other.a3262"),
				userPos:'seller',
			},
			{
				value: 5,
				label: i18n.t("other.a3263"),
				
			},
			{
				value: 6,
				label: i18n.t("other.a3264"),
				userPos:'seller',
			},
			{
				value: 7,
				label: i18n.t("other.a3265")
			},
			{
				value: 8,
				label: i18n.t("other.a3266"),
				userPos:'seller',
			},
			{
				value: 9,
				label: i18n.t("other.a3267")
			},
			{
				value: 10,
				label: i18n.t("processed.rentalexpenses"),
				userPos:'seller',
			},
			{
				value: 11,
				label: i18n.t("processed.rentalincome")
			},
			{
				value: 12,
				label: i18n.t("processed.freightexpenses"),
				userPos:'seller',
			},
			{
				value: 13,
				label: i18n.t("processed.revenue"),

			},
			{
			  value: 15,
			  label: i18n.t("processed.Preferentialincome")
			},
			{
				value: 17,
				label: i18n.t("processed.SMSrevenue")
			},
			{
				value: 18,
				label: i18n.t("processed.Inventory"),
				userPos:'seller',
			},
			{
				value: 19,
				label: i18n.t("processed.productincome")
			},
			{
				value: 20,
				label: i18n.t("processed.Customerexpenses"),
				userPos:'seller',
			},
			{
				value: 21,
				label: i18n.t("processed.complaintrevenue")
			},
			{
				value: 22,
				label: i18n.t("processed.Smart")
			},
			{
				value: 23,
				label: i18n.t("processed.Revenueservice")
			},
			{
				value: 24,
				label: i18n.t("processed.Spendingtranslation")
			},
			{
				value: 25,
				label: i18n.t("processed.Translationincome")
			},
			{
				value: 26,
				label: i18n.t("processed.Logisticsexpenses")
			},
			{
				value: 27,
				label: i18n.t("processed.Logisticsfee")
			},
			{
				value: 28,
				label: i18n.t("processed.Cashspending")
			},
			{
				value: 29,
				label: i18n.t("processed.Cashbackincome")
			},
			{
				value: 30,
				label: i18n.t("other.a3268")
			},
			{
				value: 31,
				label: i18n.t("other.a3268")
			},
			{
				value: 32,
				label: i18n.t("other.a3269")
			},
			{
				value: 33,
				label: i18n.t("other.a3270")
			},
			{
				value: 34,
				label: i18n.t("other.a3269")
			},
			{
				value: 35,
				label: i18n.t("other.a3270")
			},
			{
				value: 36,
				label: i18n.t("other.a3271")
			},
			{
				value: 37,
				label: i18n.t("other.a3272")
			},
			{
				value: 38,
				label: i18n.t("other.a3271")
			},
			{
				value: 39,
				label: i18n.t("other.a3272")
			},
			{
				value: 70,
				label: i18n.t("other.a3302")
			},
			{
				value: 71,
				label: i18n.t("other.a3301")
			},
			{
				value: 80,
				label: i18n.t("other.a3273")
			},
			{
				value: 81,
				label: i18n.t("other.a3273")
			},
			{
				value: 82,
				label: i18n.t("other.a3274")
			},
			{
				value: 83,
				label: i18n.t("other.a3274")
			},
			{
				value: 91,
				label: i18n.t("other.a3293")
			},
			{
				value: 90,
				label: i18n.t("other.a3296")
			},
			{
				value: 92,
				label: i18n.t("other.a3298")
			},
			{
				value: 93,
				label: i18n.t("other.a3299")
			},
			{
				value: 102,
				label: i18n.t("other.a3308")
			},
			{
				value: 103,
				label: i18n.t("other.a3309")
			},
			{
				value: 104,
				label: i18n.t("other.a3310")
			},
			{
				value: 105,
				label: i18n.t("other.a3311")
			},
			{
				value: 107,
				label: i18n.t("other.a3312")
			},
			{
				value: 108,
				label: i18n.t("other.a3313")
			}]
			
		  return payTypeOptions
	   },

	   reminderWords(){
		   const params={
			   'wrong sign':i18n.t("other.a1442"),
			   'item upload controller description_len no pass : lowLimit : 2 - UpperLimit : 3000':i18n.t("other.a3275"),
		   }
	   },

	   


	   //仓库积分变化名称项option
	   storePointOption(parnetFlag){
		   //0全部输出，1平台用户输出，2包一层用户输出
		let payTypeOptions=[
			{
				value: 0,
				label: i18n.t("other.a113"),
				pos:0,
			},
			{
				value: 5,
				label: i18n.t("other.a3276"),
				pos:1,
				
			},
			
			{
				value: 7,
				label: i18n.t("other.a3277"),
				pos:1,
			},
			{
				value: 11,
				label: i18n.t("processed.rentalincome"),
				pos:1,
			},
			{
				value: 9,
				label: i18n.t("other.a3278"),
				pos:1,
			},
			
			{
				value: 27,
				label: i18n.t("processed.Logisticsfee"),
				pos:0,
			},
			{
				value: 58,
				label: i18n.t("other.a3279"),
				pos:2,
			},
			{
				value: 49,
				label: i18n.t("other.a3280"),
				pos:12,
			},
			{
				value: 30,
				label: i18n.t("other.a3281"),
				pos:0,
			},
			{
				value: 31,
				label: i18n.t("other.a3282"),
				pos:0,
			},{
				value: 39,
				label: i18n.t("other.a3283"),
				pos:2,
			},
			{
				value: 35,
				label: i18n.t("other.a3284"),
				pos:2,
				
			},
			{
				value: 11,
				label: i18n.t("processed.rentalincome"),
				pos:2,
				
			},
		
		
			]

			let list=[]

			if(!parnetFlag){
				list=payTypeOptions.filter(p => {
					if(p.pos == 0 || p.pos == 1){
						return p
					}
				})
			}else{
				list=payTypeOptions.filter(p => {
					if(p.pos == 0 || p.pos == 2){
						return p
					}
				})
			}

		  return list
	   },

	   //积分日志筛选记录
	    logFilterByPayType(id,userPos){
			let storeFlag=[50,51,54,55,56]
			let sellerFlag=[]
			let falg=false
			if(userPos == 'STORE'){
				if(storeFlag.indexOf(id) == -1){
					falg=true
				}
			}
			

			return falg
		}
	
	
	
	
	

	
	
	

}